import { render, staticRenderFns } from "./base-show-checkbox.vue?vue&type=template&id=436d2e50&scoped=true"
import script from "./base-show-checkbox.vue?vue&type=script&lang=js"
export * from "./base-show-checkbox.vue?vue&type=script&lang=js"
import style0 from "./base-show-checkbox.vue?vue&type=style&index=0&id=436d2e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d2e50",
  null
  
)

export default component.exports